import request from '@/utils/request'
export function policy() {
  return request({
    url:'/aliyun/oss/policy',
    method:'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/oss.js